import { ValueOf } from 'type-fest'

export const Ticker = {
  USD: 'USD',
  EUR: 'EUR',
  UAH: 'UAH',
  BTC: 'BTC',
  ETH: 'ETH',
  BNB: 'BNB',
  TRX: 'TRX',
  POL: 'POL',
  USDT: 'USDT',
  USDC: 'USDC',
  SOL: 'SOL',
  DOGE: 'DOGE',
  PEPE: 'PEPE',
  SHIB: 'SHIB',
  LTC: 'LTC'
} as const

export type Ticker = ValueOf<typeof Ticker>

export const TICKERS = Object.values(Ticker)
